var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonCompletedUp6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.3 63.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #FF4C4A;\n      }\n\n      .cls-2 {\n        fill: #FF4C4A;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-4 {\n        opacity: .2;\n      }\n\n      .cls-5 {\n        fill: #fff;\n        isolation: isolate;\n        opacity: .2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 34.7,
    cy: 35.7,
    rx: 34.7,
    ry: 27.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 34.7,
    cy: 35.7,
    rx: 34.7,
    ry: 27.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 35.7 0 27.1 15 31.6 0 35.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "69.3 35.7 69.3 27.7 57.5 27.7 69.3 35.7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 34.7,
    cy: 27.7,
    rx: 34.7,
    ry: 27.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "25.7 26.7 31.9 33.1 43.7 22.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.5,9.1c1-.9.5-2.6-.8-2.9-1.9-.3-4-.5-6-.5-15.2,0-27.6,9.9-27.6,22s.7,5.5,1.9,7.9c.5,1,1.8,1.3,2.6.5l29.9-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.8,18.7c-1.1-2-2.6-3.8-4.3-5.4-1-.9-2.4-.9-3.5-.1l-34,27.8c-1.4,1.2-1.3,3.4.3,4.4,3.2,1.9,7,3.3,11.1,3.9.8,0,1.6-.2,2.2-.7l27.8-26.7c.8-.9,1-2.2.4-3.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCompletedUp6);
export default __webpack_public_path__ + "static/media/button_completed_up_6.c4fda18ff6f1bd1d5d3b8e3fe9130138.svg";
export { ForwardRef as ReactComponent };